import React, { useState, useRef, useEffect } from "react";
import "../css/KuyumcuDropBox.css";


const KuyumcuDropBox = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = "Seçiniz...",
  searchEnabled = true
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const boxRef = useRef();

  // Dışarı tıklayınca kapanma
  useEffect(() => {
    function handleClickOutside(e) {
      if (boxRef.current && !boxRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filtrelenmiş liste
  const filteredOptions = options.filter((o) =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="kdrop-wrapper" ref={boxRef}>
      {/* LABEL */}
      {label && <label className="kdrop-label">{label}</label>}

      {/* GÖRÜNEN ALAN */}
      <div
        className={`kdrop-display ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span className="kdrop-text">
          {value
            ? options.find((o) => o.value === value)?.label
            : placeholder}
        </span>

        <span className="kdrop-arrow"></span>
      </div>

      {/* AÇILIR MENÜ */}
      {open && (
        <div className="kdrop-options">
          {searchEnabled && (
            <input
              className="kdrop-search"
              placeholder="Ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          )}

          <div className="kdrop-scroll">
            {filteredOptions.length === 0 && (
              <div className="kdrop-empty">Sonuç yok</div>
            )}

            {filteredOptions.map((opt) => (
              <div
                key={opt.value}
                className="kdrop-option"
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                  setSearch("");
                }}
              >
                {opt.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default KuyumcuDropBox;
